/**
 * Guarda os tokens JWT (ADR 0008) no lado do cliente.
 *
 * Isolado atrás desta interface de propósito: onde o token é guardado
 * (localStorage vs. memória + cookie httpOnly) é parte da pendência de
 * segurança do ADR 0008. Trocar a estratégia deve mexer só neste arquivo.
 */

const ACCESS_KEY = 'homeai.access'
const REFRESH_KEY = 'homeai.refresh'

export interface TokenPair {
  access: string
  refresh: string
}

export const tokenStorage = {
  get access(): string | null {
    return localStorage.getItem(ACCESS_KEY)
  },
  get refresh(): string | null {
    return localStorage.getItem(REFRESH_KEY)
  },
  save(tokens: TokenPair): void {
    localStorage.setItem(ACCESS_KEY, tokens.access)
    localStorage.setItem(REFRESH_KEY, tokens.refresh)
  },
  saveAccess(access: string): void {
    localStorage.setItem(ACCESS_KEY, access)
  },
  clear(): void {
    localStorage.removeItem(ACCESS_KEY)
    localStorage.removeItem(REFRESH_KEY)
  },
}
